import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { environment } from 'environments/environment';

import {
  IPaginatedListViewSearchModel,
  KeyValuePairModel,
  ObjectCreatedResponseModel,
  PaginatedModel,
} from '../models/common.models';
import {
  ICreateSiteModel,
  ISiteDetailsModel,
  ISiteListSiteModel,
  IUpdateSiteModel,
} from '../models/site-management.models';

@Injectable({
  providedIn: 'root',
})
export class SiteManagementService {
  private searchEvent = new Subject<any>();

  searchEvent$ = this.searchEvent.asObservable();

  private get baseApiUrl(): string {
    return environment.facilityManagementUrl;
  }

  constructor(private http: HttpClient) {}

  getSitesV1(searchModel: IPaginatedListViewSearchModel): Observable<PaginatedModel<ISiteListSiteModel>> {
    const url = `${this.baseApiUrl}/v1/site`;
    const params = new HttpParams()
      .append('filterText', searchModel.searchText)
      .append('orderByColumn', searchModel.orderByColumn)
      .append('orderByDirection', searchModel.orderByDirection)
      .append('page', searchModel.page.toString())
      .append('pageSize', searchModel.pageSize.toString());

    return this.http.get<PaginatedModel<ISiteListSiteModel>>(url, {
      params,
    });
  }

  getSitesLookupV1(): Observable<KeyValuePairModel<number>[]> {
    const url = `${this.baseApiUrl}/v1/site/lookup`;
    return this.http.get<KeyValuePairModel<number>[]>(url, {});
  }

  getSiteDetailsV1(id: number): Observable<ISiteDetailsModel> {
    const url = `${this.baseApiUrl}/v1/site/${id}`;
    return this.http.get<ISiteDetailsModel>(url, {});
  }

  createSiteV1(model: ICreateSiteModel): Observable<ObjectCreatedResponseModel> {
    const url = `${this.baseApiUrl}/v1/site`;
    return this.http.post<ObjectCreatedResponseModel>(url, model);
  }

  updateSiteV1(id: number, model: IUpdateSiteModel): Observable<any> {
    const url = `${this.baseApiUrl}/v1/site/${id}`;
    return this.http.put<any>(url, model);
  }

  deleteSiteV1(id: number): Observable<any> {
    const url = `${this.baseApiUrl}/v1/site/${id}`;
    return this.http.delete<any>(url, {});
  }
}
